/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const constants = require('@utils/_constants');

/**
 * @module enervee_utils.account
 */
AccountAuthService.$inject= [
    '$q',
    '$log',
    '$http',
    '$state',
    'UserApiConsumerService',
    'UtilitySelectorCookieService',
    'UtilitySelectorService',
    'UtilService',
    'AnalyticsService',
    'GetFetchService',
    'WITH_CREDENTIALS',
    'WITHOUT_CREDENTIALS',
];
function AccountAuthService(
    $q,
    $log,
    $http,
    $state,
    UserApiConsumerService,
    UtilitySelectorCookieService,
    UtilitySelectorService,
    UtilService,
    AnalyticsService,
    GetFetchService,
    WITH_CREDENTIALS,
    WITHOUT_CREDENTIALS
) {
    var _pub = {},
        _passwordSet = null,
        _registeredUser = null,
        _currentUser = null;

    _pub.authenticationChangeCallBacks = [];
    _pub.authenticationChangeCallBacksAllPages = [];
    _pub.persistentAuthenticationChangeCallBacks = {};
    _pub.likeCallBack = null;
    _pub.saveSearchCallBack = null;

    _pub.isEmailVerificationEnabled = UtilService.isFeatureEnabled('email_verification_enabled');

    /**
     * calls the event on authentication changes
     * @param event
     * @param eventType
     */
    _pub.onAuthChange = function (event, eventType) {

        if (eventType == constants.EVENT_TYPE_LIKE) {
            _pub.likeCallBack = event;
        } else if (eventType == constants.SAVED_SEARCH_TYPE_LIKE) {
            _pub.saveSearchCallBack = event;
        } else if(eventType == constants.EVENT_SET_ELECTRICAL_UTILITY) {
            _pub.setElectricalUtilityCallback = event;
        } else {
            _pub.authenticationChangeCallBacks.push(event);
        }
    };

    /**
     * calls the event on authentication changes
     * @param event
     */
    _pub.onAuthChangeAllPages = function (event) {
        _pub.authenticationChangeCallBacksAllPages.push(event);
    }

    /**
     * calls to clear all callback functions
     */
    _pub.clearAuthChangeCallbacks = function (event) {
        _pub.authenticationChangeCallBacks = [];
    }


    _pub.onEveryAuthChange = function (key, event) {
        _pub.persistentAuthenticationChangeCallBacks[key] = event;
    };

    /**
     * Executes all auth event callbacks
     */
    var executeAuthenticationChangeCallBacks = function () {
        // Reset all the cached user data
        GetFetchService.clear('user-logged-in');
        GetFetchService.clear('profile-info');
        GetFetchService.clear('user-profile');
        GetFetchService.clear('user-profile-address');
        GetFetchService.clear('user-profile-electrical-utility');
        GetFetchService.clear('user-profile-saved-searches');
        GetFetchService.clear('user-profile-search-history');

        _pub.authenticationChangeCallBacksAllPages.forEach(function (callback) {
            callback();
        });
        _pub.authenticationChangeCallBacks.forEach(function (callback) {
            callback();
        });

        for (var key in _pub.persistentAuthenticationChangeCallBacks) {
            _pub.persistentAuthenticationChangeCallBacks[key]();
        }

        if (_pub.likeCallBack) {
            _pub.likeCallBack();
        }

        if (_pub.saveSearchCallBack) {
            _pub.saveSearchCallBack();
        }

        if (_pub.setElectricalUtilityCallback) {
            var utilityData = UtilitySelectorCookieService.getElectricalUtility();
            UtilitySelectorService.setElectricalUtility(utilityData);
        }

        _pub.likeCallBack = null;
        _pub.saveSearchCallBack = null;
        _pub.setElectricalUtilityCallback = null;
        _pub.authenticationChangeCallBacks = [];
    };

    _pub.runAuthEvents = executeAuthenticationChangeCallBacks;

    _pub.isLoggedInResponse = {
        'is_authenticated': false
    };


    /**
     * Auth service to return is a user is logged in.
     * @returns {boolean}
     */
    _pub.isAuthenticated = function () {
        return _pub.isLoggedInResponse.is_authenticated;
    };

    /**
     * Sets {withCredentials: true} if the user is authenticated, otherwise sends an object explicity setting
     * {withCredentials: false}.
     * 
     * @param {Boolean} [force=false] Force a re-fetch of the user's logged-in status
     * @returns {Promise<Object>}
     */
    _pub.getWithCredentialsOption = function (force=false) {
        return _pub.checkIfUserLoggedIn(force).then(() => {
            if (_pub.isAuthenticated()) return WITH_CREDENTIALS;
            return WITHOUT_CREDENTIALS;
        }, (err) => {
            $log.error(err);
            return false;
        });
    };


    /**
     * Sets the authentication status of the user
     *
     * @param isAuthenticated
     */
    _pub.setIsAuthenticated = function (isAuthenticated) {
        _pub.isLoggedInResponse.is_authenticated = isAuthenticated;
    };


    /**
     * Returns the status of the current user
     * @returns {string}
     */
    _pub.getUserStatus = function() {
        return _pub.isAuthenticated() ? "Registered": "Anonymous";
    };

    /**
     * Fetches the currently logged-in user's account info
     *
     * @returns {*}
     */
    _pub.fetchCurrentUserInfo = function () {
        if (_pub.isAuthenticated()) {
            var urlOptions = {
                url: 'api/1.0/profile-info/',
                requestingService: UserApiConsumerService.request
            };
            return GetFetchService.get('profile-info', urlOptions).then(
                function (response) {
                    _currentUser = response;
                }, function () {
                    _currentUser = null;
                }
            );
        }
        return $q.resolve();
    };

    /**
     * Gets the currently logged-in user's account info
     *
     * @returns {*}
     */
    _pub.getCurrentUser = function() {
        return _currentUser;
    };

    /**
     * Gets the currently logged-in user's email or null.
     * @returns {*|null}
     */
    _pub.getCurrentUserEmail = function () {
        var user = _pub.getCurrentUser();
        return user && user.email;
    };

    /**
     * Checks if the current user is logged in.
     * @returns {Promise}
     */
    _pub.checkIfUserLoggedIn = function (force) {
        force = force || false;
        var urlOptions = {
            url: 'api/1.0/token/',
            requestingService: UserApiConsumerService.request
        };
        return GetFetchService.get('user-logged-in', urlOptions, {force: force}).then(function (response) {
            _pub.setIsAuthenticated(response.is_authenticated);
            return response;
        });
    };

    /**
     * Service to log in a user and set user information in a session.
     *
     * @param {string} email
     * @param {string} password
     * @returns {*}
     */
    _pub.logIn = function (email, password) {

        var credentials = {'username': email, 'password': password};
        return setUserToken(credentials);
    };

    function setUserToken (params) {

        return UserApiConsumerService.post('api/1.0/token/', params)
            .then(
                function(response) {
                    _pub.isLoggedInResponse = {
                        'is_authenticated': true
                    };
                    executeAuthenticationChangeCallBacks();
                },
                function(response) {
                    _pub.isLoggedInResponse = {
                        'is_authenticated': false,
                        'error': response.data.non_field_errors
                    };
                }
            );
    };

    function _logout(user) {
        var currentView = $state.current.name;
        var email = user.email;

        UserApiConsumerService.delete('api/1.0/token/').then(function (response) {
            _pub.isLoggedInResponse = {
                'is_authenticated': false
            };

            executeAuthenticationChangeCallBacks();

            AnalyticsService.reportEvent('Signed Out', {
                email: email
            }).then(function () {
                AnalyticsService.resetSegmentUser();
            });

            if (UtilService.getSetting('loggedInRequiredStates', []).indexOf(currentView) !== -1) {
                $state.go('index');
            } else {
                $state.reload();
            }
        });
    }

    /**
     * Service to log out a user
     * @returns {*}
     */
    _pub.logout = function () {
        var user = _pub.getCurrentUser();
        if (user === null) {
            _pub.fetchCurrentUserInfo().then(function() {
                user = _pub.getCurrentUser();
                _logout(user);
            });
        } else {
            _logout(user);
        }
    };

    /**
     * Returns logout response
     * @returns {*}
     */
    _pub.getLogoutResponse = function () {
        return _loggedOutResponse;
    };

    /**
     * Resets user password
     * @param newPassword
     * @param confirmPassword
     * @param token Django rest framework issued token.
     * @param userId
     * @returns {*}
     */
    _pub.setNewUserPassword = function (newPassword, confirmPassword, resetToken, userId) {
        var data = {
            'new_password1': newPassword,
            'new_password2': confirmPassword,
            'token': resetToken,
            'uid': userId
        };
        var options = {
            method: 'POST',
            url: 'api/1.0/rest-auth/password/reset/confirm/',
            data: data
        };
        var withCredentials = false;

        return UserApiConsumerService.request(options, withCredentials)
            .then(
                // success
                function (response) {
                    _passwordSet = {
                        'set': true,
                        'status': response.status,
                        'message': response.message
                    };

                    if (response.token) {
                        executeAuthenticationChangeCallBacks();
                    }
                },
                // error
                function (response) {
                    var data = response.data;
                    _passwordSet = {'set':  false};

                    if ('non_field_errors' in data) {
                        _passwordSet.error  = data.non_field_errors;
                    } else if ('uid' in data) {
                       _passwordSet.error = data.uid;
                    } else if ('new_password1' in data) {
                        _passwordSet.error = data.new_password1[0];
                    } else if ('new_password2' in data) {
                        _passwordSet.error = data.new_password2[0];
                    }
                    executeAuthenticationChangeCallBacks();
                }
            );
    };

    /**
     * returns an object if a new password was set
     * @returns {*}
     */
    _pub.wasNewPasswordSet = function () {
        return _passwordSet;
    };


    /**
     * Registers a user and creates a password-less account.
     *
     * @param {String} email - User email entered from the login/signup process.
     * @returns {Promise} - returns the user registeration's promise
     */
    _pub.registerUser = function (email) {
        var data = {'email': email};

        return UserApiConsumerService.post('api/1.0/rest-auth/registration/', data, WITHOUT_CREDENTIALS)
            .then(
                // success
                function (response) {
                    if (response.data.key) {
                        _registeredUser = {
                            'registered': true,
                            'status': response.status,
                            'key': response.data.key
                        };

                        _pub.setIsAuthenticated(true);
                        setUserToken ({username: email, key:response.data.key});
                    }
                },
                // error
                function(response) {
                    _registeredUser = {
                        'registered': false,
                        'status': response.status,
                        'error': response.data
                    };
                }
            );
    };


    /**
     * Verifies email account
     * @param key for user email verification
     * @returns {*}
     */
    _pub.verifyEmailAccount = function (key) {
        var data = {'key': key};

        return UserApiConsumerService.post('api/1.0/account-confirm-email/', data)
            .then(
                // success
                function(response) {
                    _registeredUser = {
                        'activated': response.data.activated,
                        'isFullUser': response.data.full_user,
                        'emailAddress': response.data.email_address
                    };
                    return _registeredUser;
                },
                // error
                function(response) {
                    _registeredUser = {
                        'activated': false,
                        'error': response.data
                    };
                    return $q.reject(_registeredUser);
                }
            );
    };

    /**
     * returns an object if a new user was registered.
     * @returns {*}
     */
    _pub.wasUserRegistered = function () {
        return _registeredUser;
    };

    /**
     * returns an object if found Iterable user.
     * @param userId Iterable user id
     * @returns {*}
     */
    _pub.getIterableUserData = function (userId) {
        const data = {'userId': userId};

        return UserApiConsumerService.post('api/1.0/identify-user/', data, WITHOUT_CREDENTIALS)
            .then(
                // success
                function(response) {
                    return response.data;
                },
                // error
                function(response) {
                    $log.warn(response.data.detail);
                    return $q.reject({});
                }
            );
    };

    return _pub;
}

module.exports = AccountAuthService;